function getTotalScrollHeight() {
    var h = document.documentElement,
        b = document.body,
        sh = 'scrollHeight'
    return (h[sh] || b[sh]) - h.clientHeight
}

function getCurrentScrollPercent() {
    var h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight'
    return (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)
}

function getMousePositionNormalized(event) {
    const x = (event.clientX / window.innerWidth) * 2 - 1
    const y = -(event.clientY / window.innerHeight) * 2 + 1
    return { x, y }
}

function getComplementaryColor(color = '') {
    const colorPart = color.slice(1)
    const ind = parseInt(colorPart, 16)
    let iter = ((1 << 4 * colorPart.length) - 1 - ind).toString(16)
    while (iter.length < colorPart.length) {
        iter = '0' + iter
    }
    return '#' + iter
}

/**
 * Native scrollTo with callback
 * @param offset - offset to scroll to
 * @param callback - callback function
 */
function scrollToPosition(offset, callback) {
    const onScroll = function () {
        if (Math.abs(window.scrollY - offset) < 2) {
            window.removeEventListener('scroll', onScroll)
            callback()
        }
    }

    window.addEventListener('scroll', onScroll)
    onScroll()
    window.scrollTo({
        top: offset,
        behavior: 'smooth'
    })
}

function isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768;
}

export {
    getCurrentScrollPercent,
    getTotalScrollHeight,
    getComplementaryColor,
    scrollToPosition,
    isMobile,
    getMousePositionNormalized
}
